import React, { useState } from 'react'
import _ from 'lodash'
import { Row, Space, Form, Select, InputNumber, Avatar } from 'antd'
import { useDeepEffect } from '../../../utils/hooks'
import DeleteIcon from '@material-ui/icons/Delete'
import IconButton from '@material-ui/core/IconButton'
import { getQuantityLabel } from '../../../utils'
import { PanelEx, TableEx, CollapseEx, ListDiv, Text } from '../index.style'
import { ButtonEx } from '../../HeroLocations/index.style'
import CardComponent from '../../../components/CardComponent'
import LogoNoMaterial from '../../../assets/images/icon_no_material_402x.png'
import { QUANTITY_OPTIONS } from '../../../utils/constants'

const EditMaterial = (props) => {
  const { onChangePage, myProducts, me, onSaveMaterialProduct } = props
  const [productFormList, setProductFormList] = useState([])
  const [activeKeys, setActiveKeys] = useState([])
  const [form] = Form.useForm()

  useDeepEffect(() => {
    setProductFormList(myProducts)
  }, [])

  useDeepEffect(() => {
    if (!_.isEmpty(productFormList)) {
      productFormList.forEach((item, index) => {
        if (!_.isEmpty(item.products)) {
          setActiveKeys((prevState) => {
            prevState.push(`${index + 1}`)
            return [...prevState]
          })
        }
      })

      productFormList.forEach((item) => {
        item.products.forEach((product) => {
          form.setFieldsValue({
            [`minQuantity_${getId(product)}`]: product.minQuantity,
            [`price_${getId(product)}`]: product.price || 0.0
          })
        })
      })
    }
  }, [productFormList])

  function callback(key) {
    setActiveKeys(key)
  }

  const checkProduct = () => {
    let haveProduct = false
    myProducts.forEach((item) => {
      if (!_.isEmpty(item.products)) {
        haveProduct = true
      }
    })

    return haveProduct
  }

  const columns = [
    {
      title: 'วัสดุ',
      key: 'material',
      dataIndex: 'material',
      align: 'center',
      width: 600,
      render: (text, record) => {
        return (
          <Row justify="start">
            <Space>
              <img height={48} width={48} src={text.image} alt="" />
              <span>{text.name}</span>
            </Space>
          </Row>
        )
      }
    },
    {
      title: 'ราคาที่รับ',
      key: 'price',
      align: 'center',
      width: 150,
      render: (text, record) => (
        <Form.Item
          name={`price_${getId(record)}`}
          rules={[
            {
              required: true,
              message: 'กรุณากรอกราคาที่รับ'
            }
          ]}>
          <InputNumber step="0.01" min={0} />
        </Form.Item>
      )
    },
    {
      title: 'จำนวนที่รับ',
      key: 'minQuantity',
      align: 'center',
      width: 150,
      render: (text, record) => (
        <Form.Item
          name={`minQuantity_${getId(record)}`}
          rules={[
            {
              required: true,
              message: 'กรุณาเลือกจำนวนที่รับ'
            }
          ]}>
          <Select>
            {QUANTITY_OPTIONS.map((item, index) => {
              return (
                <Select.Option key={index} value={item.name}>
                  {getQuantityLabel(item.name)}
                </Select.Option>
              )
            })}
          </Select>
        </Form.Item>
      )
    },
    {
      title: 'ลบวัสดุ',
      key: 'delete',
      align: 'center',
      width: 150,
      render: (text, record) => {
        return (
          <IconButton
            aria-label="Delete"
            onClick={() => removeItem(getId(record))}>
            <DeleteIcon color="secondary" />
          </IconButton>
        )
      }
    }
  ]

  const getId = (record) => {
    if (!_.isUndefined(record.id)) {
      return record.id
    } else {
      return record.material.id
    }
  }

  const removeItem = (productId) => {
    setProductFormList((prevState) => {
      prevState.forEach((item) => {
        item.products = item.products.filter((product) => {
          return getId(product) !== productId
        })
      })

      return [...prevState]
    })
  }

  const onFinish = async (values) => {
    const arr = []
    productFormList.forEach((item) => {
      item.products.forEach((product) => {
        const data = {
          heroId: me.id,
          materialId: product.material.id,
          minQuantity: values[`minQuantity_${getId(product)}`],
          price: values[`price_${getId(product)}`]
        }
        arr.push(data)
      })
    })

    await onSaveMaterialProduct(arr)
  }

  return (
    <Form form={form} onFinish={onFinish}>
      <ListDiv>
        <CardComponent>
          {checkProduct() ? (
            <div>
              <CollapseEx
                activeKey={activeKeys}
                onChange={(key) => callback(key)}
                expandIconPosition="right">
                {!_.isEmpty(productFormList) &&
                  productFormList.map((item, index) => {
                    return !_.isEmpty(item.products) ? (
                      <PanelEx
                        key={index + 1}
                        id={item.categoryId}
                        header={
                          <Row justify="center">
                            <span style={{ color: 'white', fontSize: 18 }}>
                              {item.categoryName}
                            </span>
                          </Row>
                        }>
                        <TableEx
                          id={item.id}
                          rowKey={(record) => {
                            return record.material.id
                          }}
                          dataSource={item.products}
                          columns={columns}
                          scroll={{ x: 800 }}
                          pagination={false}
                        />
                      </PanelEx>
                    ) : null
                  })}
              </CollapseEx>
            </div>
          ) : (
            <CardComponent>
              <div
                style={{
                  display: 'flex',
                  justifyContent: 'center',
                  alignItems: 'center',
                  height: 500
                }}>
                <Space direction="vertical">
                  <Row justify="center">
                    <Avatar size={72} src={LogoNoMaterial} />
                  </Row>
                  <Text size={20}>คุณยังไม่มีวัสดุรีไซเคิลที่รับซื้อ</Text>
                </Space>
              </div>
            </CardComponent>
          )}
        </CardComponent>
        <Row justify="center">
          <Space>
            <ButtonEx
              color="#707070"
              type="primary"
              onClick={() => onChangePage('list')}>
              ย้อนกลับ
            </ButtonEx>
            <ButtonEx color="#6ebf4b" type="primary" htmlType="submit">
              บันทึกข้อมูล
            </ButtonEx>
          </Space>
        </Row>
      </ListDiv>
    </Form>
  )
}

export default EditMaterial



// WEBPACK FOOTER //
// ./src/pages/AccountProduct/EditMaterial/index.js